export async function sha256(obj: any): Promise<string> {
    const stableStringify = (input: any): string => {
        if (Array.isArray(input)) {
            return `[${input.map(stableStringify).join(',')}]`;
        } else if (input && typeof input === 'object') {
            const keys = Object.keys(input).sort();
            return `{${keys.map(k => `"${k}":${stableStringify(input[k])}`).join(',')}}`;
        } else {
            return JSON.stringify(input);
        }
    };

    const text = stableStringify(obj);
    const encoder = new TextEncoder();
    const data = encoder.encode(text);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(hashBuffer))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
}
